




let hoverTimer = null;
let activePopup = null; // currently open popup reference

function showSuggestionPopup(editor, match, spanEl) {
  const iframeDoc = editor.getDoc();
  const iframeBody = editor.getBody();

  //popup remove
  if (activePopup) {
    activePopup.remove();
    activePopup = null;
  }

  const spanRect = spanEl.getBoundingClientRect();
  const scrollTop = iframeDoc.documentElement.scrollTop || iframeDoc.body.scrollTop || 0;
  const scrollLeft = iframeDoc.documentElement.scrollLeft || iframeDoc.body.scrollLeft || 0;

  const spanAbsTop = spanRect.top + scrollTop;
  const spanAbsBottom = spanRect.bottom + scrollTop;
  const spanAbsLeft = spanRect.left + scrollLeft;

  const iframeHeight = iframeDoc.documentElement.clientHeight;
  const iframeWidth = iframeDoc.documentElement.clientWidth;

  const popup = iframeDoc.createElement("div");
  popup.className = "suggestion-popup";

  Object.assign(popup.style, {
    position: "absolute",
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "10px",
    zIndex: "99999",
    boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
    fontSize: "14px",
    minWidth: "220px",
    maxWidth: "280px",
    visibility: "hidden",
  });

  popup.innerHTML = `
    <div style="position:relative;">
      <span class="popup-close" style="position:absolute;top:-12px;right:0;cursor:pointer;font-weight:bold;font-size:16px;">&times;</span>
      <div style="margin-top:12px;margin-bottom:15px;color:#4a5568; display:flex; gap: 8px; flex-wrap:wrap; align-items:center">
      <strong>Convert</strong>
      <div style="padding:3px 8px;width:fit-content; max-width:200px;background:#fef5f5;border-radius:4px;border:1px solid #fed7d7;color:#c53030;">${match.text}</div>
      <strong>to</strong>
       <div style="padding:3px 8px;background:#f0fff4;border-radius:4px;border:1px solid #c6f6d5;color:#22543d;">${match.suggested}</div>
      </div>
      
      <div style="display:flex;gap:8px; justify-content:end;">
      <button class="suggestion-ignore" style="background:#eee;border:none;padding:5px 14px;border-radius:4px;cursor:pointer;">Ignore</button>
        <button class="suggestion-accept" style="background:#22c55e;color:#fff;border:none;padding:5px 14px;border-radius:4px;cursor:pointer;">Accept</button>        
      </div>
    </div>`;

  iframeBody.appendChild(popup);
  activePopup = popup;

  // Size measure
  const popupH = popup.offsetHeight;
  const popupW = popup.offsetWidth;
  const GAP = 8;

  // Vertical position
  const spaceBelow = iframeHeight - spanRect.bottom;
  const spaceAbove = spanRect.top;
  let topPos;
  if (spaceBelow >= popupH + GAP) {
    topPos = spanAbsBottom + GAP;
  } else if (spaceAbove >= popupH + GAP) {
    topPos = spanAbsTop - popupH - GAP;
  } else {
    topPos = scrollTop + Math.max(GAP, iframeHeight - popupH - GAP);
  }

  // Horizontal position
  const spaceRight = iframeWidth - spanRect.left;
  let leftPos;
  if (spaceRight >= popupW + GAP) {
    leftPos = spanAbsLeft;
  } else {
    leftPos = scrollLeft + iframeWidth - popupW - GAP;
  }

  leftPos = Math.max(scrollLeft + GAP, leftPos);
  topPos = Math.max(scrollTop + GAP, topPos);

  popup.style.top = topPos + "px";
  popup.style.left = leftPos + "px";
  popup.style.visibility = "visible";

  // Close logic 

  let closeTimer = null;

  const scheduleClose = () => {
    closeTimer = setTimeout(() => {

      if (!popup.matches(":hover")) {
        close();
      }
    }, 100);
  };

  const cancelClose = () => {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  };

  const close = () => {
    cancelClose();
    popup.remove();
    if (activePopup === popup) activePopup = null;
  };

  // Span mouseleave → close schedule (100ms delay)
  spanEl.addEventListener("mouseleave", scheduleClose);

  // Popup mouseenter → cancel close 
  popup.addEventListener("mouseenter", cancelClose);

  // Popup mouseleave → close 
  popup.addEventListener("mouseleave", (e) => {

    if (e.relatedTarget === spanEl || spanEl.contains(e.relatedTarget)) {
      return;
    }
    close();
  });



  // close button
  popup.querySelector(".popup-close").onclick = close;

  // Accept
  popup.querySelector(".suggestion-accept").onclick = () => {
    editor.undoManager.transact(() => {

      iframeDoc.querySelectorAll(`span[data-suggestion-uid="${match.uid}"]`).forEach(sp => {

        if (match.styleId === "pValueLowerItalic") {

          const em = iframeDoc.createElement("em");
          em.textContent = match.suggested;
          const p = sp.parentNode;
          p.insertBefore(em, sp);
          p.removeChild(sp);

        } else if (match.styleId === "unitRomanFont") {

          const p = sp.parentNode;
          const romanSpan = iframeDoc.createElement("span");
          romanSpan.style.fontStyle = "normal";
          romanSpan.textContent = match.suggested;
          p.insertBefore(romanSpan, sp);
          p.removeChild(sp);

        } else {
          // Other styles → normal text replace
          sp.textContent = match.suggested;
          const p = sp.parentNode;
          while (sp.firstChild) p.insertBefore(sp.firstChild, sp);
          p.removeChild(sp);
        }

      });
      editor.nodeChanged();
    });
    match.processed = true;
    window.dispatchEvent(new CustomEvent("suggestion-accepted", { detail: { uid: match.uid } }));
    close();
  };

  // Ignore
  // popup.querySelector(".suggestion-ignore").onclick = () => close();

  popup.querySelector(".suggestion-ignore").onclick = () => {
  const ed = editor;
  const doc = ed.getDoc();

  ed.undoManager.transact(() => {

    doc.querySelectorAll(`span[data-suggestion-uid="${match.uid}"]`).forEach(sp => {
      const parent = sp.parentNode;

      while (sp.firstChild) {
        parent.insertBefore(sp.firstChild, sp);
      }
      parent.removeChild(sp);
    });

  });

  match.processed = true;

  window.dispatchEvent(
    new CustomEvent("suggestion-rejected", { detail: { uid: match.uid } })
  );
};
}

function injectHighlightSpans(editor, matches, cssClass) {
  if (!matches || matches.length === 0) return;
  const doc = editor.getDoc();

  

  const byNode = new Map();
  matches.forEach(m => {
    console.log("Current match:", m);
    if (!byNode.has(m.node)) byNode.set(m.node, []);
    byNode.get(m.node).push(m);
    console.log("Current byNode:", byNode);
  });
  byNode.forEach((nodeMatches, textNode) => {
    nodeMatches.sort((a, b) => b.start - a.start);
    nodeMatches.forEach(match => {
      if (match.processed) return;
      try {
        textNode.splitText(match.end);
        const middle = textNode.splitText(match.start);
        const span = doc.createElement("span");
        span.setAttribute("data-suggestion-uid", match.uid);
        span.setAttribute("data-suggestion-style", cssClass);
        if (match.styleId) span.setAttribute("data-styleId", match.styleId);

        span.setAttribute("contenteditable", "false");
        
        span.style.cssText = cssClass === "highlight-degree"
          ? "background:rgba(255,200,0,0.45);border-bottom:2px solid orange;cursor:pointer;"
          : cssClass === "p-lower-italic"
            ? "background:rgba(64,150,255,0.25);border-bottom:2px solid #4096ff;cursor:pointer;"
            : "background:rgba(64,150,255,0.25);border-bottom:2px solid #4096ff;cursor:pointer;";
        span.className = cssClass;

        middle.parentNode.insertBefore(span, middle);
        span.appendChild(middle);

        const zeroWidthSpace = doc.createTextNode("\u200B");
        span.parentNode.insertBefore(zeroWidthSpace, span.nextSibling);

        span.addEventListener("mouseenter", () => {
          // match.processed OR span data-processed attribute → popup close
          if (match.processed) return;
          if (span.getAttribute("data-processed") === "true") return;
          hoverTimer = setTimeout(() => {
            if (!match.processed && span.getAttribute("data-processed") !== "true") {
              showSuggestionPopup(editor, match, span);
            }
          }, 800);
        });

        span.addEventListener("mouseleave", () => {

          clearTimeout(hoverTimer);
          hoverTimer = null;

        });

        match.spanEl = span;
        console.log("spanEl", match.spanEl);
      } catch (e) { console.warn("inject error:", e); }
    });
  });

  
}










export function silentRemoveAllSpans(editor) {
  const doc = editor?.getDoc();
  if (!doc) return;
 
  // 1. Suggestion popups remove
  doc.querySelectorAll(".suggestion-popup").forEach(p => p.remove());
 
  
  doc.querySelectorAll("span[data-suggestion-uid]").forEach(sp => {
    const p = sp.parentNode;
    if (!p) return;
    while (sp.firstChild) p.insertBefore(sp.firstChild, sp);
    p.removeChild(sp);
  });
 
  
  const walker = doc.createTreeWalker(
    doc.body,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );
  const zeroWidthNodes = [];
  let node;
  while ((node = walker.nextNode())) {
    if (node.nodeValue && node.nodeValue.includes('\u200B')) {
      zeroWidthNodes.push(node);
    }
  }
  zeroWidthNodes.forEach(n => {
    n.nodeValue = n.nodeValue.replace(/\u200B/g, '');
  });
 
  
  if (doc.body) {
    doc.body.normalize();
  }
 
  if (activePopup) { activePopup.remove(); activePopup = null; }
}



export function silentRemoveActiveSpans(editor) {
  const doc = editor?.getDoc();
  if (!doc) return;
 
  doc.querySelectorAll("span[data-suggestion-uid]:not([data-rejected])").forEach(sp => {
    const p = sp.parentNode;
    if (!p) return;
    while (sp.firstChild) p.insertBefore(sp.firstChild, sp);
    p.removeChild(sp);
  });
 
  
  const walker = doc.createTreeWalker(
    doc.body,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );
  const zeroWidthNodes = [];
  let node;
  while ((node = walker.nextNode())) {
    if (node.nodeValue && node.nodeValue.includes('\u200B')) {
      zeroWidthNodes.push(node);
    }
  }
  zeroWidthNodes.forEach(n => {
    n.nodeValue = n.nodeValue.replace(/\u200B/g, '');
  });
 
  if (doc.body) doc.body.normalize();
}
 
export function markSpanRejected(editor, uid) {
  const doc = editor?.getDoc();
  if (!doc) return;
  doc.querySelectorAll(`span[data-suggestion-uid="${uid}"]`).forEach(sp => {
    sp.setAttribute("data-rejected", "true");
    sp.setAttribute("data-processed", "true");
    sp.style.cssText = "";
  });
}



export function acceptSpan(editor, uid, newText) {


  const doc = editor.getDoc();
  if (!doc) return;

  doc.querySelectorAll(`span[data-suggestion-uid="${uid}"]`).forEach(sp => {
    const styleId = sp.getAttribute("data-styleId");
    const p = sp.parentNode;

    if (styleId === "pValueLowerItalic") {

      const em = doc.createElement("em");
      em.textContent = newText;
      p.insertBefore(em, sp);
      p.removeChild(sp);

    } else if (styleId === "unitRomanFont") {

      const romanSpan = doc.createElement("span");
      romanSpan.style.fontStyle = "normal";
      romanSpan.textContent = newText;
      p.insertBefore(romanSpan, sp);
      p.removeChild(sp);

    } else {
      // All other styles → normal text replace
      sp.textContent = newText;
      while (sp.firstChild) p.insertBefore(sp.firstChild, sp);
      p.removeChild(sp);
    }
  });

  editor.nodeChanged();
}

function findMatches(editor, styleId, pattern, styleName) {
  const matches = [];
  const doc = editor.getDoc();
  const walker = doc.createTreeWalker(
    editor.getBody(), NodeFilter.SHOW_TEXT,
    {
      acceptNode(node) {
        const parent = node.parentNode;
        if (!parent) return NodeFilter.FILTER_ACCEPT;
        if (parent.getAttribute?.("data-suggestion-uid")) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    }, false
  );
  let node;
  while ((node = walker.nextNode())) {
    const text = node.nodeValue;
    let m; pattern.lastIndex = 0;
    while ((m = pattern.exec(text)) !== null) {
      const uid = `${styleId}-${Math.random().toString(36).slice(2, 9)}`;
      matches.push({
        text: m[0], node,
        start: m.index, end: m.index + m[0].length,
        processed: false, name: styleName, styleId, uid,
      });
    }
  }
  return matches;
}

export const Customstyles = {
  degreeToSymbol: {
    id: "degreeToSymbol",
    name: "Convert 'degree' to °",
    description: "Suggests replacing deg/degree/degrees with ° .",
    beforeImage: "/images/degree-before.png",
    afterImage: "/images/degree-after.png",
    markerClass: "highlight-degree",

    pattern: /\b\d+(?:\.\d+)?\s*(deg|degree|degrees)\s*(Celsius)?\b/gi,

    execute(editor) {
      if (!editor) return [];

      const matches = findMatches(editor, this.id, this.pattern, this.name);
      if (!matches.length) return [];

      matches.forEach(m => {
        const numMatch = m.text.match(/\d+(?:\.\d+)?/);
        if (!numMatch) return;

        const number = numMatch[0];

        
        const hasCelsius = /Celsius/i.test(m.text);

        if (hasCelsius) {
          m.suggested = `${number}°C`;
        } else {
          m.suggested = `${number}°`;
        }
      });

      injectHighlightSpans(editor, matches, this.markerClass);
      return matches;
    }
  },

  correctIE_EGCommas: {
    id: "correctIE_EGCommas", name: "Add comma after i.e. and e.g.",
    description: "Detects 'i.e.' and 'e.g.' not followed by a comma.",
    beforeImage: "/images/i.e-before.png", afterImage: "/images/i.e-after.png",
    markerClass: "highlight-punctuation", pattern: /\b(i\.e\.|e\.g\.)(?!,)/gi,
    execute(editor) {
      if (!editor) return [];
      const matches = findMatches(editor, this.id, this.pattern, this.name);
      if (!matches.length) return [];
      matches.forEach(m => { m.suggested = m.text + ","; });
      injectHighlightSpans(editor, matches, this.markerClass);
      return matches;
    }
  },
  ltdWithDot: {
    id: "ltdWithDot", name: "Add dot after Ltd",
    description: "Ensures 'Ltd' is followed by a dot.",
    beforeImage: "/images/Ltd-before.png", afterImage: "/images/Ltd-after.png",
    markerClass: "highlight-punctuation", pattern: /\bLtd\b(?!\.)/g,
    execute(editor) {
      if (!editor) return [];
      const matches = findMatches(editor, this.id, this.pattern, this.name);
      if (!matches.length) return [];
      matches.forEach(m => { m.suggested = m.text + "."; });
      injectHighlightSpans(editor, matches, this.markerClass);
      return matches;
    }
  },
  unitSpacing: {
    id: "unitSpacing", name: "Add space between number and unit",
    description: "Ensures a space between number and unit (e.g., 2cm → 2 cm).",
    beforeImage: "/images/unit-before.png", afterImage: "/images/unit-after.png",
    markerClass: "highlight-punctuation",
    pattern: /(\d)(mm|cm|km|mg|kg|g|min|h|s|mL|L|m|°C)(²)?\b/g,

    execute(editor) {
      if (!editor) return [];
      const body = editor.getBody(), doc = editor.getDoc(), matches = [];

      const walker = doc.createTreeWalker(body, NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            return node.parentNode?.getAttribute?.("data-suggestion-uid")
              ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
          }
        }, false);

      let node;
      while ((node = walker.nextNode())) {
        const text = node.nodeValue;
        this.pattern.lastIndex = 0;
        let m;

        while ((m = this.pattern.exec(text)) !== null) {
          const full = m[0], num = m[1], unit = m[2], pow = m[3] || "";

          // already spaced
          if (text[m.index + 1] === " ") continue;

          const nextText = text.slice(m.index + full.length);


          if (unit === "°C") {
            const match = nextText.match(/^\s*\/\s*(min|h|s)\b/i);
            if (!match) continue;

            const corrected = "/" + match[1];

            const uid = `${this.id}-${Math.random().toString(36).slice(2, 9)}`;

            matches.push({
              text: full + match[0],
              suggested: `${num} ${unit}${corrected}`,
              node,
              start: m.index,
              end: m.index + full.length + match[0].length,
              processed: false,
              name: this.name,
              styleId: this.id,
              uid
            });

            continue;
          }

          // existing skip
          if (nextText.startsWith("%")) continue;

          const uid = `${this.id}-${Math.random().toString(36).slice(2, 9)}`;

          matches.push({
            text: full,
            suggested: `${num} ${unit}${pow}`,
            node,
            start: m.index,
            end: m.index + full.length,
            processed: false,
            name: this.name,
            styleId: this.id,
            uid
          });
        }
      }

      if (!matches.length) return [];
      injectHighlightSpans(editor, matches, this.markerClass);
      return matches;
    }
  },


  percentageRepeat: {
    id: "percentageRepeat",
    name: "Repeat % symbol for all numbers",
    description: "If a sentence contains %, all numbers in that sentence should have % (e.g., 117% and 29 → 117% and 29%).",
    beforeImage: "/images/percentage-before.png",
    afterImage: "/images/percentage-after.png",
    markerClass: "highlight-punctuation",

    execute(editor) {
      if (!editor) return [];

      const matches = [];
      const doc = editor.getDoc();
      const body = editor.getBody();
      const unitRegex = /^\s*(mm|cm|km|ms|mg|kg|g|min|h|s|mL|L|m\u00b2?|\u00b0C|\u00b0F)\b/;

      const walker = doc.createTreeWalker(
        body, NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            if (node.parentNode?.getAttribute?.("data-suggestion-uid"))
              return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        }, false
      );

      let node;
      while ((node = walker.nextNode())) {
        const fullText = node.nodeValue;


        const sentences = fullText.split(/(?<!\d)\.(?!\d)|[!?;]/);
        let offset = 0;

        sentences.forEach(sentence => {

          if (!sentence.includes("%")) {
            offset += sentence.length + 1; // +1 for split char
            return;
          }

          //Numbers scan: decimal support \b\d+(\.\d+)?\b
          const numRegex = /\b\d+(?:\.\d+)?\b/g;
          let numMatch;

          while ((numMatch = numRegex.exec(sentence)) !== null) {
            const num = numMatch[0];
            const localIndex = numMatch.index;
            const globalIndex = offset + localIndex;

            // Already % → skip
            if (sentence[localIndex + num.length] === "%") continue;

            // 4-digit year → skip
            if (/^\d{4}$/.test(num)) continue;

            // Hyphen-preceded → skip (e.g., 2020-2021)
            if (sentence[localIndex - 1] === "-") continue;

            // Letter-preceded → skip (e.g., "A53")
            const charBefore = sentence[localIndex - 1];
            if (charBefore && /[a-zA-Z]/.test(charBefore)) continue;

            // Letter-followed → skip (e.g., "53K", "25th")
            const charAfterNum = sentence[localIndex + num.length];
            if (charAfterNum && /[a-zA-Z]/.test(charAfterNum)) continue;

            // Unit-followed → skip (e.g., "25 ms", "5kg")
            const afterText = sentence.slice(localIndex + num.length);
            if (unitRegex.test(afterText)) continue;

            const uid = `${this.id}-${Math.random().toString(36).slice(2, 9)}`;
            matches.push({
              text: num,
              suggested: num + "%",
              node,
              start: globalIndex,
              end: globalIndex + num.length,
              processed: false,
              name: this.name,
              styleId: this.id,
              uid,
            });
          }

          offset += sentence.length + 1;
        });
      }

      if (!matches.length) return [];
      injectHighlightSpans(editor, matches, this.markerClass);
      return matches;
    }
  },

  temperatureRepeat: {
    id: "temperatureRepeat",
    name: "Repeat °C symbol for all numbers",
    description: "If a sentence contains °C, all numbers in that sentence should have °C (e.g., 1.1 and 2.6°C → 1.1°C and 2.6°C).",
    beforeImage: "/images/temp-before.png",
    afterImage: "/images/temp-after.png",
    markerClass: "highlight-punctuation",

    execute(editor) {
      if (!editor) return [];

      const matches = [];
      const doc = editor.getDoc();
      const body = editor.getBody();
      const unitRegex = /^\s*(mm|cm|km|ms|mg|kg|g|min|h|s|mL|L|m\u00b2?|\u00b0C|\u00b0F)\b/;

      const walker = doc.createTreeWalker(
        body, NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            if (node.parentNode?.getAttribute?.("data-suggestion-uid"))
              return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        }, false
      );

      let node;
      while ((node = walker.nextNode())) {
        const fullText = node.nodeValue;

        // Split on . only when NOT between digits (decimal safe)
        const sentences = fullText.split(/(?<!\d)\.(?!\d)|[!?;]/);
        let offset = 0;

        sentences.forEach(sentence => {

          if (!sentence.includes("\u00b0C")) {
            offset += sentence.length + 1;
            return;
          }

          const numRegex = /\b\d+(?:\.\d+)?\b/g;
          let numMatch;

          while ((numMatch = numRegex.exec(sentence)) !== null) {
            const num = numMatch[0];
            const localIndex = numMatch.index;
            const globalIndex = offset + localIndex;

            // Already °C → skip
            const afterNum = sentence.slice(localIndex + num.length);
            if (afterNum.startsWith("\u00b0C")) continue;

            // 4-digit year → skip
            if (/^\d{4}$/.test(num)) continue;

            // Hyphen-preceded → skip
            if (sentence[localIndex - 1] === "-") continue;

            // Letter-preceded → skip (e.g., "A53")
            const charBefore = sentence[localIndex - 1];
            if (charBefore && /[a-zA-Z]/.test(charBefore)) continue;

            // Letter-followed → skip (e.g., "53K", "25th")
            // NOTE: ° alone does NOT skip — afterNum.startsWith("°C") already handles °C
            const charAfterNum = sentence[localIndex + num.length];
            if (charAfterNum && /[a-zA-Z]/.test(charAfterNum)) continue;

            // Unit-followed → skip (e.g., "25 ms", "5kg")
            if (unitRegex.test(afterNum)) continue;

            const uid = `${this.id}-${Math.random().toString(36).slice(2, 9)}`;
            matches.push({
              text: num,
              suggested: num + "\u00b0C",
              node,
              start: globalIndex,
              end: globalIndex + num.length,
              processed: false,
              name: this.name,
              styleId: this.id,
              uid,
            });
          }

          offset += sentence.length + 1;
        });
      }

      if (!matches.length) return [];
      injectHighlightSpans(editor, matches, this.markerClass);
      return matches;
    }
  },

  siUnits: {
    id: "siUnits",
    name: "Follow SI units (h, min, s)",
    description: "Converts hours/hrs/hr → h, minutes/mins → min, seconds/secs/sec → s with the number.",
    beforeImage: "/images/si-before.png",
    afterImage: "/images/si-after.png",
    markerClass: "highlight-punctuation",

    execute(editor) {
      if (!editor) return [];

      const matches = [];
      const doc = editor.getDoc();
      const body = editor.getBody();

      // Pattern: number (with optional decimal) + optional space + unit word
      const siPattern = /(\d+(?:\.\d+)?)\s*(hours?|hrs?|minutes?|mins?|seconds?|secs?)\b/gi;

      const walker = doc.createTreeWalker(
        body, NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            if (node.parentNode?.getAttribute?.("data-suggestion-uid"))
              return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        }, false
      );

      let node;
      while ((node = walker.nextNode())) {
        const text = node.nodeValue;
        siPattern.lastIndex = 0;
        let m;

        while ((m = siPattern.exec(text)) !== null) {
          const num = m[1];
          const unitWord = m[2].toLowerCase();
          const fullMatch = m[0];

          // Determine SI unit
          let siUnit;
          if (/^hours?$|^hrs?$/.test(unitWord)) siUnit = 'h';
          else if (/^minutes?$|^mins?$/.test(unitWord)) siUnit = 'min';
          else if (/^seconds?$|^secs?$/.test(unitWord)) siUnit = 's';
          else continue;

          const suggested = num + ' ' + siUnit;

          // Already correct SI unit — skip
          if (fullMatch.trim() === suggested) continue;

          const uid = `${this.id}-${Math.random().toString(36).slice(2, 9)}`;
          matches.push({
            text: fullMatch,
            suggested: suggested,
            node,
            start: m.index,
            end: m.index + fullMatch.length,
            processed: false,
            name: this.name,
            styleId: this.id,
            uid,
          });
        }
      }

      if (!matches.length) return [];
      injectHighlightSpans(editor, matches, this.markerClass);
      return matches;
    }
  },

  unitRange: {
    id: "unitRange",
    name: "Remove repeated unit in ranges",
    description: "In ranges, unit should appear only at the end (e.g., 10 nm–15 nm → 10–15 nm).",
    beforeImage: "/images/unit-range-before.png",
    afterImage: "/images/unit-range-after.png",
    markerClass: "highlight-punctuation",

    execute(editor) {
      if (!editor) return [];
      const matches = [];
      const doc = editor.getDoc();
      const body = editor.getBody();
      const unitPat = 'nm|mm|cm|km|µm|ms|mg|kg|g|min|h|mL|L|kHz|MHz|GHz|Hz|°C|°F|%|s|m';
      const r = new RegExp(
        '(\\d+(?:\\.\\d+)?)\\s*(' + unitPat + ')\\s*([-\u2013\u2014])\\s*(\\d+(?:\\.\\d+)?)\\s*(' + unitPat + ')',
        'gi'
      );

      const walker = doc.createTreeWalker(body, NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            return node.parentNode?.getAttribute?.("data-suggestion-uid")
              ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
          }
        }, false);

      let node;
      while ((node = walker.nextNode())) {
        const text = node.nodeValue;
        r.lastIndex = 0;
        let m;
        while ((m = r.exec(text)) !== null) {
          const n1 = m[1], u1 = m[2], dash = m[3], n2 = m[4], u2 = m[5];
          if (u1.toLowerCase() !== u2.toLowerCase()) continue;
          const full = m[0];
          const suggested = n1 + dash + n2 + ' ' + u1;
          if (full === suggested) continue;
          const uid = `${this.id}-${Math.random().toString(36).slice(2, 9)}`;
          matches.push({
            text: full, suggested, node,
            start: m.index, end: m.index + full.length,
            processed: false, name: this.name, styleId: this.id, uid
          });
        }
      }
      if (!matches.length) return [];
      injectHighlightSpans(editor, matches, this.markerClass);
      return matches;
    }
  },

  unitSeries: {
    id: "unitSeries",
    name: "Remove repeated unit in series",
    description: "In a series, unit should appear only at the end (e.g., 10 s, 15 s and 25 s → 10, 15, and 25 s).",
    beforeImage: "/images/unit-series-before.png",
    afterImage: "/images/unit-series-after.png",
    markerClass: "highlight-punctuation",

    execute(editor) {
      if (!editor) return [];
      const matches = [];
      const doc = editor.getDoc();
      const body = editor.getBody();
      const unitPat = 'nm|mm|cm|km|µm|ms|mg|kg|g|min|h|mL|L|kHz|MHz|GHz|Hz|s|m';
      const itemReg = new RegExp(
        '(\\d+(?:\\.\\d+)?)\\s*(' + unitPat + ')(?=\\s|,|$)',
        'gi'
      );

      const walker = doc.createTreeWalker(body, NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            return node.parentNode?.getAttribute?.("data-suggestion-uid")
              ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
          }
        }, false);

      let node;
      while ((node = walker.nextNode())) {
        const text = node.nodeValue;

        // Collect all num+unit items in this text node
        itemReg.lastIndex = 0;
        const allItems = [];
        let m;
        while ((m = itemReg.exec(text)) !== null) {
          allItems.push({ num: m[1], unit: m[2], start: m.index, end: m.index + m[0].length });
        }
        if (allItems.length < 2) continue;

        // Build groups of consecutive same-unit items
        const allGroups = [];
        for (let i = 0; i < allItems.length; i++) {
          const group = [allItems[i]];
          let j = i + 1;
          while (j < allItems.length) {
            const between = text.slice(allItems[j - 1].end, allItems[j].start);
            if (/^[\s,]*(?:and|or)?[\s,]*$/.test(between) && between.trim().length > 0) {
              group.push(allItems[j]);
              j++;
            } else break;
          }
          if (group.length >= 2) {
            const fu = group[0].unit.toLowerCase();
            if (group.every(g => g.unit.toLowerCase() === fu)) allGroups.push([...group]);
          }
        }

        // Deduplicate: keep longest non-overlapping groups
        allGroups.sort((a, b) => b.length - a.length);
        const usedItems = new Set();
        const finalGroups = [];
        for (const group of allGroups) {
          const keys = group.map(g => g.start);
          if (keys.some(k => usedItems.has(k))) continue;
          keys.forEach(k => usedItems.add(k));
          finalGroups.push(group);
        }

        for (const group of finalGroups) {
          const fullStart = group[0].start;
          const fullEnd = group[group.length - 1].end;
          const full = text.slice(fullStart, fullEnd);
          const hasOr = /\bor\b/i.test(full);
          const nums = group.map(g => g.num);
          let suggested;
          if (nums.length === 2) {
            suggested = nums[0] + ' ' + (hasOr ? 'or' : 'and') + ' ' + nums[1] + ' ' + group[0].unit;
          } else {
            const last = nums[nums.length - 1];
            const rest = nums.slice(0, -1);
            suggested = rest.join(', ') + ', ' + (hasOr ? 'or' : 'and') + ' ' + last + ' ' + group[0].unit;
          }
          if (full === suggested) continue;

          const uid = `${this.id}-${Math.random().toString(36).slice(2, 9)}`;
          matches.push({
            text: full, suggested, node,
            start: fullStart, end: fullEnd,
            processed: false, name: this.name, styleId: this.id, uid
          });
        }
      }
      if (!matches.length) return [];
      injectHighlightSpans(editor, matches, this.markerClass);
      return matches;
    }
  },

  unitMultiplication: {
    id: "unitMultiplication",
    name: "Repeat unit in multiplication",
    description: "Ensures units are repeated in multiplication expressions (e.g., 160 × 160 × 3 mm → 160 mm × 160 mm × 3 mm).",
    beforeImage: "/images/unit-mul-before.png",
    afterImage: "/images/unit-mul-after.png",
    markerClass: "highlight-punctuation",

    execute(editor) {
      if (!editor) return [];

      const matches = [];
      const doc = editor.getDoc();
      const body = editor.getBody();

      const unitPat = 'mm|cm|km|m|mg|kg|g|µm|nm|mL|L';


      const r = new RegExp(
        '(\\d+(?:\\.\\d+)?)(?:\\s*[×x]\\s*(\\d+(?:\\.\\d+)?)){1,}\\s*(' + unitPat + ')\\b',
        'gi'
      );

      const walker = doc.createTreeWalker(
        body,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            return node.parentNode?.getAttribute?.("data-suggestion-uid")
              ? NodeFilter.FILTER_REJECT
              : NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );

      let node;
      while ((node = walker.nextNode())) {
        const text = node.nodeValue;
        r.lastIndex = 0;

        let m;
        while ((m = r.exec(text)) !== null) {
          const full = m[0];


          const nums = full.match(/\d+(?:\.\d+)?/g);
          const unit = m[m.length - 1];

          if (!nums || nums.length < 2) continue;


          const suggested = nums.map(n => `${n} ${unit}`).join(' × ');

          if (full === suggested) continue;

          const uid = `${this.id}-${Math.random().toString(36).slice(2, 9)}`;

          matches.push({
            text: full,
            suggested,
            node,
            start: m.index,
            end: m.index + full.length,
            processed: false,
            name: this.name,
            styleId: this.id,
            uid
          });
        }
      }

      if (!matches.length) return [];
      injectHighlightSpans(editor, matches, this.markerClass);
      return matches;
    }
  },

  operatorSpacingFull: {
    id: "operatorSpacingFull",
    name: "Normalize operator spacing (only equations)",
    description: "Applies spacing only when '=' is present (e.g., a+b=10 → a + b = 10).",
    beforeImage: "/images/operator-before.png",
    afterImage: "/images/operator-after.png",
    markerClass: "highlight-punctuation",

    execute(editor) {
      if (!editor) return [];

      const matches = [];
      const doc = editor.getDoc();
      const body = editor.getBody();

      // Expression MUST contain '='
      const exprRegex = /\b[a-zA-Z0-9+\-×÷]*=[a-zA-Z0-9+\-×÷]*\b/g;

      const walker = doc.createTreeWalker(
        body,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            return node.parentNode?.getAttribute?.("data-suggestion-uid")
              ? NodeFilter.FILTER_REJECT
              : NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );

      let node;
      while ((node = walker.nextNode())) {
        const text = node.nodeValue;
        exprRegex.lastIndex = 0;

        let m;
        while ((m = exprRegex.exec(text)) !== null) {
          const full = m[0];


          if (!full.includes('=')) continue;


          if (!/[a-zA-Z]/.test(full)) continue;


          if (/^[a-zA-Z\-]+$/.test(full)) continue;


          let suggested = full
            .replace(/\s*([+\-×÷=])\s*/g, ' $1 ')
            .replace(/\s+/g, ' ')
            .trim();

          if (full === suggested) continue;

          const uid = `${this.id}-${Math.random().toString(36).slice(2, 9)}`;

          matches.push({
            text: full,
            suggested,
            node,
            start: m.index,
            end: m.index + full.length,
            processed: false,
            name: this.name,
            styleId: this.id,
            uid
          });
        }
      }

      if (!matches.length) return [];

      injectHighlightSpans(editor, matches, this.markerClass);
      return matches;
    }
  },

  pValueLowerItalic: {
    id: "pValueLowerItalic",
    name: "Format p value (lowercase + italic)",
    description: "Convert 'P' to lowercase italic 'p' only when followed by space or comparison operators.",
    beforeImage: "/images/p-before.png",
    afterImage: "/images/p-after.png",
    markerClass: "p-lower-italic",

    execute(editor) {
      if (!editor) return [];

      const matches = [];
      const body = editor.getBody();

      const doc = editor.getDoc();
      const regex = /\bP(?=\s*(?:value|[-–]?\s*[<>=]))/gi;

      const walker = document.createTreeWalker(
        body,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            return node.parentNode?.getAttribute?.("data-suggestion-uid")
              ? NodeFilter.FILTER_REJECT
              : NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );

      let node;
      while ((node = walker.nextNode())) {
        const text = node.nodeValue;
        regex.lastIndex = 0;

        let m;
        while ((m = regex.exec(text)) !== null) {
          const uid = `${this.id}-${Math.random().toString(36).slice(2, 9)}`;
          matches.push({
            text: "P",
            suggested: "p",
            node,
            start: m.index,
            end: m.index + 1,
            processed: false,
            styleId: this.id,
            uid
          });
        }
      }

      if (!matches.length) return [];


      injectHighlightSpans(editor, matches, this.markerClass);

      return matches;
    }
  },

  unitRomanFont: {
    id: "unitRomanFont",
    name: "Unit should be roman (not italic)",
    description: "If a unit (mm, cm, kg, etc.) appears in italic font, suggests converting it to roman (normal) font style.",
    beforeImage: "/images/unit-roman-before.png",
    afterImage: "/images/unit-roman-after.png",
    markerClass: "highlight-punctuation",

    execute(editor) {
      if (!editor) return [];

      const matches = [];
      const doc = editor.getDoc();
      const body = editor.getBody();

      const UNITS = ["mm", "cm", "km", "µm", "nm", "mg", "kg", "g", "mL", "L", "min", "h", "s", "Hz", "kHz", "MHz", "GHz", "°C", "°F", "%", "m"];


      function isItalic(el) {
        let cur = el;
        while (cur && cur !== body) {
          const tag = cur.tagName?.toLowerCase();
          if (tag === "em" || tag === "i") return true;
          const style = cur.getAttribute?.("style") || "";
          if (/font-style\s*:\s*(italic|oblique)/i.test(style)) return true;
          cur = cur.parentNode;
        }
        return false;
      }


      function precedingTextEndsWithNumber(textNode) {
        let prev = textNode.previousSibling;
        while (prev) {
          if (prev.nodeType === Node.TEXT_NODE) {
            const t = prev.nodeValue;
            if (t.trim() === "") { prev = prev.previousSibling; continue; }
            return /\d+(?:\.\d+)?\s*$/.test(t);
          }
          if (prev.nodeType === Node.ELEMENT_NODE) {
            const t = prev.textContent || "";
            return /\d+(?:\.\d+)?\s*$/.test(t);
          }
          prev = prev.previousSibling;
        }

        const parentPrev = textNode.parentNode?.previousSibling;
        if (parentPrev) {
          const t = parentPrev.textContent || "";
          return /\d+(?:\.\d+)?\s*$/.test(t);
        }
        return false;
      }

      const walker = doc.createTreeWalker(
        body,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            if (node.parentNode?.getAttribute?.("data-suggestion-uid"))
              return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );

      let node;
      while ((node = walker.nextNode())) {
        if (!node.parentNode) continue;

        const text = node.nodeValue;
        const trimmed = text.trim();


        if (UNITS.includes(trimmed) && isItalic(node)) {
          if (precedingTextEndsWithNumber(node)) {
            const start = text.indexOf(trimmed);
            const uid = `${this.id}-${Math.random().toString(36).slice(2, 9)}`;
            matches.push({
              text: trimmed,
              suggested: trimmed,
              node,
              start,
              end: start + trimmed.length,
              processed: false,
              name: this.name,
              styleId: this.id,
              uid,
            });
          }
          continue;
        }


        if (!isItalic(node)) continue;

        const unitRegex = new RegExp(
          `(\\d+(?:\\.\\d+)?)\\s*(${UNITS.map(u => u.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})\\b`,
          'g'
        );
        let m;
        while ((m = unitRegex.exec(text)) !== null) {
          const fullMatch = m[0];
          const unit = m[2];
          const unitStart = m.index + fullMatch.length - unit.length;
          const uid = `${this.id}-${Math.random().toString(36).slice(2, 9)}`;
          matches.push({
            text: unit,
            suggested: unit,
            node,
            start: unitStart,
            end: unitStart + unit.length,
            processed: false,
            name: this.name,
            styleId: this.id,
            uid,
          });
        }
      }

      if (!matches.length) return [];
      injectHighlightSpans(editor, matches, this.markerClass);
      return matches;
    }
  },


};



